import { forwardRef } from 'react'
import type { IconProps } from '../icon-props'
import { Icon } from '../icon'
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMzQzIDE3LjY1N0E4IDggMCAxIDEgMTcuNjU3IDYuMzQzIDggOCAwIDAgMSA2LjM0MyAxNy42NTdtNC40LTEuNDE0TDcgMTIuNTNsMS40MTUtMS40MTQgMi4zMjggMi4yOTcgNC45NS00Ljk1IDEuNDE0IDEuNDE1eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) */
export const IconCheckCircle = forwardRef<SVGElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path
            fill="#111928"
            fillRule="evenodd"
            d="M6.343 17.657A8 8 0 1 1 17.657 6.343 8 8 0 0 1 6.343 17.657m4.4-1.414L7 12.53l1.415-1.414 2.328 2.297 4.95-4.95 1.414 1.415z"
            clipRule="evenodd"
        />
    </Icon>
))
IconCheckCircle.displayName = 'IconCheckCircle'
